export class TagFlatNode {
    id: string;
    title: string;
    url: string;
    level: number;
    isVisible: boolean;
    expandable: boolean;
    edition: boolean;
    error: string;
}